module.exports = __webpack_public_path__ + "media/images/icon-special-b427016ca4d36e22f1dd0aaa8549dc9c.svg";